export default __webpack_public_path__ + "static/media/upgrade_house.fde7aca7.png";